import { theme } from './theme';

// Reads the categorical chart palette fresh from CSS custom properties on
// every call (never cache into a module-level constant — CSS may not be
// parsed yet when this module first evaluates).
export const getAnalyticsColors = () => theme.chartCategorical();

export const buildTitle = (title, subtitle) => ({
  text: title,
  left: 'left',
  top: 8,
  textStyle: {
    color: theme.chartTitleText(),
    fontSize: 14,
    fontWeight: 700,
  },
  subtext: subtitle,
  subtextStyle: {
    color: theme.chartSubtitleText(),
    fontSize: 12,
  },
});

export const buildTooltip = () => ({
  trigger: 'item',
  backgroundColor: theme.chartTooltipBg(),
  borderColor: theme.chartTooltipBorder(),
  borderWidth: 1,
  textStyle: {
    color: theme.chartTooltipText(),
  },
  extraCssText: `box-shadow: 0 10px 28px rgba(${theme.chartTooltipTextRgb()}, 0.18);`,
});

export const buildLegend = (position = 'top') => ({
  top: position === 'top' ? 40 : 'auto',
  left: 'center',
  textStyle: {
    color: theme.chartAxisLabel(),
  },
  itemWidth: 14,
  itemHeight: 14,
  type: 'scroll',
  orient: 'horizontal',
});

export const buildGrid = () => ({
  left: '12%',
  right: '10%',
  top: '20%',
  bottom: '12%',
  containLabel: true,
});

export const buildAxisStyle = () => ({
  axisLine: {
    lineStyle: {
      color: theme.chartAxisLine(),
    },
  },
  axisTick: {
    show: false,
  },
  splitLine: {
    lineStyle: {
      color: theme.chartGridLine(),
    },
  },
  axisLabel: {
    color: theme.chartAxisLabel(),
    fontSize: 11,
  },
});

export const buildToolbox = () => ({
  show: true,
  top: 10,
  right: 10,
  feature: {
    saveAsImage: {
      title: 'Export PNG',
      iconStyle: { borderColor: theme.chartAxisLine() },
    },
    restore: {
      title: 'Reset',
      iconStyle: { borderColor: theme.chartAxisLine() },
    },
    dataZoom: {
      title: {
        zoom: 'Zoom',
        back: 'Reset Zoom',
      },
      iconStyle: { borderColor: theme.chartAxisLine() },
    },
  },
});

export const buildDataZoom = () => ([
  {
    type: 'inside',
    xAxisIndex: [0],
    filterMode: 'weakFilter',
  },
  {
    type: 'slider',
    xAxisIndex: [0],
    height: 20,
    bottom: 0,
    start: 0,
    end: 100,
    borderColor: theme.chartZoomTrackBorder(),
    backgroundColor: theme.chartZoomTrackBg(),
  },
]);
